import { Link } from 'react-router-dom';
import { motion } from 'framer-motion';
import personSoloDev from '@/assets/person-solo-dev.jpg';
import personTeamLead from '@/assets/person-team-lead.jpg';
import personEnterprise from '@/assets/person-enterprise.jpg';
import bgTech4 from '@/assets/bg-tech-4.jpg';

const personas = [
  {
    image: personSoloDev,
    title: 'Solo Builders',
    bullets: [
      'Deploy AI agents that handle planning, building, and QA',
      'Ship faster without hiring overhead',
      'Start free and scale when workload grows',
    ],
    cta: 'Start building',
  },
  {
    image: personTeamLead,
    title: 'Product Teams',
    bullets: [
      'Orchestrate agents alongside human teammates in real time',
      'Accelerate sprint delivery with autonomous task execution',
      'Standardize quality with skill injection and guardrails',
    ],
    cta: 'Try with your team',
  },
  {
    image: personEnterprise,
    title: 'Enterprise Orgs',
    bullets: [
      'Governed AI agents with policy-gated approvals',
      'Full audit trails for compliance and security teams',
      'Scale agent workloads across squads without tool sprawl',
    ],
    cta: 'Talk to sales',
  },
];

const PersonaCTAs = () => {
  return (
    <section className="section-padding relative overflow-hidden">
      <div className="absolute inset-0 -z-10">
        <img src={bgTech4} alt="" className="h-full w-full object-cover" />
        <div className="absolute inset-0 bg-background/80 backdrop-blur-sm" />
      </div>
      <div className="mx-auto max-w-7xl relative z-10">
        <motion.div
          initial={{ opacity: 0, y: 16 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          className="text-center"
        >
          <h2 className="text-3xl font-bold tracking-tight text-foreground sm:text-4xl">
            Built for every team size
          </h2>
          <p className="mt-4 text-muted-foreground">
            From solo founders to enterprise engineering organizations — deploy agentic AI
            workflows with the control you need.
          </p>
        </motion.div>

        <div className="mt-8 grid gap-6 md:grid-cols-3">
          {personas.map((persona, i) => (
            <motion.div
              key={i}
              initial={{ opacity: 0, y: 16 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ delay: i * 0.1 }}
              className="glass-card-hover flex flex-col rounded-2xl p-8"
            >
              <img
                src={persona.image}
                alt={persona.title}
                className="mb-5 h-16 w-16 rounded-full object-cover ring-2 ring-primary/20"
              />
              <h3 className="text-lg font-semibold text-foreground">{persona.title}</h3>
              <ul className="mt-4 flex-1 space-y-2.5">
                {persona.bullets.map((bullet, j) => (
                  <li key={j} className="flex items-start gap-2 text-sm text-muted-foreground">
                    <span className="mt-1.5 h-1.5 w-1.5 shrink-0 rounded-full bg-primary" />
                    {bullet}
                  </li>
                ))}
              </ul>
              {i < 2 ? (
                <Link
                  to="/login"
                  className="mt-8 inline-flex items-center justify-center rounded-lg border border-border bg-secondary px-5 py-2.5 text-sm font-medium text-foreground transition-colors hover:border-primary/30"
                >
                  {persona.cta}
                </Link>
              ) : (
                <a
                  href="mailto:sales@tasking.tech?subject=Enterprise%20Inquiry"
                  className="mt-8 inline-flex items-center justify-center rounded-lg border border-border bg-secondary px-5 py-2.5 text-sm font-medium text-foreground transition-colors hover:border-primary/30"
                >
                  {persona.cta}
                </a>
              )}
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default PersonaCTAs;
